<template lang="pug">
.container-signup
  auth-card
    .col-group(style="margin:0 auto")
      gb-input(
        label="管理者名",
        v-model="user_name"
      )
      gb-input(
        label="管理者名（カナ）",
        v-model="user_name_kana"
      )
      gb-input(
        label="メールアドレス",
        v-model="email"
      )
      gb-input(
        label="パスワード"
        type="password"
        v-model="password"
      )
    div.block(style="margin:0 auto")
      .col-group
        gb-button.primary(
          @clicked="signUp"
        ) サインアップ
      .col-group(style="margin-top:20px;")
        .to-signin(@click="toSignIn") ログイン画面へ
</template>

<script>
import util from '@/api/util'

import AuthCard from '@/components/organisms/AuthCard.vue'
import GbButton from '@/components/atoms/GbButton.vue'
import GbInput from '@/components/atoms/GbInput.vue'

export default {
  components: {
    AuthCard,
    GbButton,
    GbInput
  },
  data () {
    return {
      email: null,
      password: null,
      register_name: null,
      register_name_kana: null,
      user_name: null,
      user_name_kana: null
    }
  },
  methods: {
    toSignIn () {
      this.$router.push({ name: 'SignIn' })
    },
    async signUp () {
      if (this.user_name === '' || this.user_name === null) {
        this.$swal.fire({text: `管理者名を入力してください`})
        return
      } else if (this.user_name_kana === '' || this.user_name_kana === null) {
        this.$swal.fire({text: `管理者名（カナ）を入力してください`})
        return
      } else if (this.email === '' || this.email === null) {
        this.$swal.fire({text: `メールアドレスを入力してください`})
        return
      } else if (this.password === '' || this.password === null || this.password.length < 6) {
        this.$swal.fire({text: `パスワードを6文字以上で入力してください`})
        return
      }
      try {
        const COG_REQUEST_VALUE = {
          username: this.email,
          password: this.password,
          attributes: {
            name: this.user_name,
            nickname: this.user_name_kana
          }
        }
        const Response = (await util.createMethod('COG', 'signUp', COG_REQUEST_VALUE))
        if (Response) this.$swal.fire({html: `確認用メールを送信しました<br>メールを確認しサインアップを完了させてください`})
      } catch (error) {
        if (error.code === 'UsernameExistsException') this.$swal.fire({html: `このメールアドレスはすでに利用されています`})
        else if (error.message) this.$swal.fire({text: `${error.message}`})
        else this.$swal.fire({html: `エラーが発生しました<br>時間をおいてもう一度お試しください`})
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../stylus/main.styl'
fontFamily = 'Open Sans', sans-serif
.to-signin
  font-size 10px
  color $color-secondary
  text-align center
  cursor pointer
.container-signup
  width 100vw
  height 100vh
  display flex
  justify-content center
  align-items center
.col-group
  display flex
  flex-direction column
.block
  display block
  margin 0 auto
</style>



// WEBPACK FOOTER //
// src/views/SignUp.vue